// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@keyframes animate-skeleton{0%{transform:translateX(-100%) translateY(-50%)}to{transform:translateX(100%) translateY(-50%)}}.x-btn .x-btn-medium{height:40px;padding:0 20px}.white--text .x-btn *{color:#fff;caret-color:#fff}", ""]);
// Exports
module.exports = exports;
